// extracted by mini-css-extract-plugin
export default {"wrapper":"Vy","noPadding":"Wy","flavor_wrapper":"Xy","flavor_button":"Yy","vert":"Zy","itemContent":"az","itemName":"bz","blue":"cz","out_of_stock":"ez","newFlavorBadge":"fz","fullWidth":"gz","flavor_button_selected":"hz","black":"iz","attribute_wrapper":"jz","toggle_wrapper":"kz"};
    if(module.hot) {
      // 1715091678793
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  